import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import Polling from "../../utils/polling";
import Emitter from "../../emitter";
import {
  AGENT_STATUS_LIST,
  API_AGENT_CHANGE,
  API_CHANGE_AGENT_STATE,
} from "../../constants/constants";
import storeRTK from "../../store/storeRTK";
import { setLoader } from "../../actions/common";
import { Flex, Item, Key, Picker, Text, View } from "@adobe/react-spectrum";
import { AgentState } from "../../types/agent.type";
import { RootState } from "../../store";

/**
 * Map Store State to Component Props
 * @param {*} state
 */
function mapStateToProps(state: RootState) {
  return {
    call: state.call,
    agent: state.agent,
    loggedIn: state.session.loggedIn,
    history: state.history,
    callback: state.callback,
    session: state.session,
    webrtc: state.webrtc,
  };
}
let stateModifiedDate: number;
const AgentStatusChange: React.FC = (props: any) => {
  const [stateChangeTimerDuration, setStateChangeTimerDuration] = useState(0);
  const [stateChangeTimerEnabled, setStateChangeTimerEnabled] = useState(false);
  const [currentState, setCurrentState] = useState<Key>(props.agent?.state?.id);
  const [allowedStates, setAllowedStates] = useState(
    props.agent?.states?.allowedStates
  );
  const canStateTimerbeEnabled = true;

  useEffect(() => {
    stateModifiedDate = props.agent.stateModifiedDate;
  }, [props.agent.stateModifiedDate]);
  const stateChangeTimer = (continuePoll: any, pollingInstance: any) => {
    if (props.call && props.agent && !canStateTimerbeEnabled) {
      pollingInstance.stop();
      setStateChangeTimerEnabled(false);
    }

    setStateChangeTimerDuration(
      Math.max(0, new Date().getTime() - (stateModifiedDate as number))
    );
    continuePoll();
  };

  const polling = new Polling(stateChangeTimer, 1000);

  useEffect(() => {
    if (props.agent?.state?.id === "AfterCallWork") {
      // Add the object only if it's not already in allowedStates
      setAllowedStates((prevStates: AgentState[]) => {
        if (
          !prevStates.some((state: AgentState) => state.id === "AfterCallWork")
        ) {
          return [
            ...prevStates,
            {
              id: "AfterCallWork",
              routable: "false",
              connect_arn: "",
              displayName: "AfterCallWork",
            },
          ];
        }
        return prevStates;
      });
    } else {
      setAllowedStates(props.agent?.states?.allowedStates);
    }
    setCurrentState(props.agent.state?.id);
  }, [props.agent.state?.id]);

  useEffect(() => {
    startChangeStateTimer();
    Emitter.on(API_CHANGE_AGENT_STATE, stateUpdated);
    return () => {
      polling.stop();
      Emitter.removeListener(API_CHANGE_AGENT_STATE, stateUpdated);
    };
  }, []);

  const stateUpdated = () => {
    startChangeStateTimer();
    // props.onSubmit();
  };

  const startChangeStateTimer = () => {
    if (props.loggedIn && !polling.hasStarted() && canStateTimerbeEnabled) {
      setStateChangeTimerEnabled(true);
      polling.start();
    }
  };

  const getTimerString = () => {
    let secs = 0;
    let mins = 0;
    let hrs = 0;
    if (stateChangeTimerEnabled) {
      secs = Math.floor(stateChangeTimerDuration / 1000);
      if (secs >= 60) {
        mins = Math.floor(secs / 60);
        secs = secs % 60;
      }
      if (mins >= 60) {
        hrs = Math.floor(mins / 60);
        mins = mins % 60;
      }
    }

    return `${hrs.toString().padStart(2, "0")}:${mins
      .toString()
      .padStart(2, "0")}:${secs.toString().padStart(2, "0")}`;
  };

  const updateState = (state: Key) => {
    // if value is there in clicked agent state. Since clicking on same agent state returns {}
    // if ([...state][0]) {
    //   // issue occurs if agent state before ACW is clicked again. acwState has previous agentStatus.
    //   if (props?.agent?.acwState?.id) {
    //     //get latest call and callback and compare their end times.
    //     let latestCall = props?.history?.conversations[0];
    //     let latestCallback = props?.history?.callback[0];

    //     let latestCallEndTime = latestCall?.self?.endTime
    //       ? latestCall.self?.endTime
    //       : "0";
    //     let latestCallbackEndTime = latestCallback?.self?.endTime
    //       ? latestCallback.self?.endTime
    //       : "0";
    //     let participantId = "";
    //     let conversationId = "";

    //     if (
    //       new Date(latestCallEndTime).getTime() -
    //         new Date(latestCallbackEndTime).getTime() >
    //       0
    //     ) {
    //       participantId = latestCall.self.id;
    //       conversationId = latestCall.id;
    //     } else {
    //       participantId = latestCallback.self.id;
    //       conversationId = latestCallback.id;
    //     }

    //     // if values are there for participant id and conversation id
    //     if (participantId && conversationId) {
    //       // wrap up the callback/call.
    //       // sendMessage({
    //       //   body: {
    //       //     wrapupCode: DEFAULT_WRAPUP_CODE,
    //       //     participantId: participantId,
    //       //     conversationId: conversationId,
    //       //   },
    //       //   chan: API_CALL_WRAPUP,
    //       //   type: "req",
    //       // });
    //       // sendMessage({
    //       //     body: {
    //       //         wrapupCode: DEFAULT_WRAPUP_CODE,
    //       //         participantId: participantId,
    //       //         conversationId: conversationId,
    //       //     },
    //       //     chan: API_CALL_WRAPUP,
    //       //     type: 'req',
    //       // });
    //     }
    //   }
    // }
    if (currentState !== state) {
      // setCurrentState(state);
      Emitter.emit(API_AGENT_CHANGE, { agentState: state });
    } else {
      console.log(
        `Agent status is already set to ${props.agent.state.displayName}`
      );
      storeRTK.dispatch(setLoader(false));
    }
    // callback();
  };

  return (
    <Flex UNSAFE_className="agentStatusChangeWrapper">
      <Picker
        UNSAFE_className={"agentStatusChangePicker"}
        label={"Status"}
        labelPosition="side"
        menuWidth="size-3400"
        items={allowedStates
          ?.filter((s: AgentState) =>
            [AGENT_STATUS_LIST.ON_QUEUE, AGENT_STATUS_LIST.AVAILABLE].includes(
              s.displayName
            )
          )
          .concat(
            allowedStates
              .filter(
                (s: AgentState) =>
                  ![
                    AGENT_STATUS_LIST.ON_QUEUE,
                    AGENT_STATUS_LIST.AVAILABLE,
                  ].includes(s.displayName)
              )
              .sort((a: AgentState, b: AgentState) =>
                a.displayName.localeCompare(b.displayName)
              )
          )}
        onSelectionChange={(selected) => {
          if (selected !== null) {
            updateState(selected);
          }
        }}
        selectedKey={currentState}
        isDisabled={props.webrtc.ccpSessionState !== 4}
      >
        {(item: AgentState) => (
          <Item key={item.displayName} textValue={item.displayName}>
            {/* Added textValue */}
            <Text UNSAFE_className="agent-status-text">
              {item.displayName === "Available"
                ? "Not ready"
                : item.displayName}
            </Text>
          </Item>
        )}
      </Picker>
      <View
        marginStart={"size-100"}
        alignSelf={"center"}
        UNSAFE_className="status-timer"
      >
        {stateChangeTimerEnabled && (
          <Text UNSAFE_style={{ color: "#000" }}>{getTimerString()}</Text>
        )}
      </View>
    </Flex>
  );
};

export default connect(mapStateToProps)(AgentStatusChange);
